import React from 'react'

export default function BookmarksItemsSimple({ className='', children }) {
    return (
        <div className={'ui-bm-view-simple'+' '+className}>
            {children}
        </div>
    )
}